import { FC } from 'react';
import { Select } from '@mantine/core';
import { ChangeEventStatusConfigDTO, WorkflowConfigProps } from '../../../../../Types/LogT';
import { DataS } from '../../../../../Service/DataS';
import AvailabilityIcon from '../../../../../Atoms/AvailabilityIcon';
import BookingState from '../../../../../Types/Enums/BookingState';

const ChangeEventStatusConfig: FC<WorkflowConfigProps> = ({ config, handleChange }) => {
  const { bookingState } = config as ChangeEventStatusConfigDTO;

  return (
    <Select
      label="Neuer Status"
      defaultValue={bookingState}
      data={DataS.getBookingStateOptions()}
      onChange={(state) => handleChange({ bookingState: state as BookingState })}
      icon={bookingState && <AvailabilityIcon bookingState={bookingState as BookingState} />}
    />
  );
};

export default ChangeEventStatusConfig;
